import { ReceiversPage } from '@apps-common/apps/portal/pages/receivers/Index'

export const Receivers = () => <ReceiversPage />
